import axios from 'axios'

export default axios.create({
    baseURL: "https://event-spot-backend.onrender.com"
    // baseURL: "https://localhost://3333"

})